import type { TicketAnalyticsDayBucket } from "@/queries/analytics/ticket-reporting-types";

export function isValueInDistributionBucket(value: number, bucket: TicketAnalyticsDayBucket): boolean {
  switch (bucket) {
    case "lessThan1Day":
      return value < 1;
    case "1To3Days":
      return value >= 1 && value < 4;
    case "4To7Days":
      return value >= 4 && value < 8;
    case "8To14Days":
      return value >= 8 && value < 15;
    case "15DaysOrMore":
      return value >= 15;
  }
}
